import { render } from "./LocationNotFound.vue?vue&type=template&id=3d3a134a&scoped=true"
import script from "./LocationNotFound.vue?vue&type=script&lang=js"
export * from "./LocationNotFound.vue?vue&type=script&lang=js"

import "./LocationNotFound.vue?vue&type=style&index=0&id=3d3a134a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d3a134a"]])

export default __exports__